/**
 * Portaled row tooltip aligned to the pointer X axis and anchored above the row top.
 *
 * @module TableRowCursorTooltipPortal
 */
import React from "react";
import { createPortal } from "react-dom";
import { computeCursorTopTooltipPosition } from "../toolTipUsingPortal/toolTipUsingPortal";

/** Active row tooltip position and content. */
export interface RowCursorTooltipState {
  /** Tooltip body to render */
  content: React.ReactNode;
  /** Pointer X in viewport coordinates */
  clientX: number;
  /** Row top edge Y in viewport coordinates */
  anchorTop: number;
}

interface TableRowCursorTooltipPortalProps {
  /** Current tooltip state, or null when hidden */
  tooltip: RowCursorTooltipState | null;
}

/**
 * Renders a single cursor-aligned tooltip in `document.body`.
 *
 * @param props.tooltip - Active tooltip state from row hover tracking
 * @returns Portaled tooltip node, or null when inactive
 */
export const TableRowCursorTooltipPortal = ({
  tooltip,
}: TableRowCursorTooltipPortalProps) => {
  if (!tooltip?.content) {
    return null;
  }

  return createPortal(
    <div
      role="tooltip"
      className="custom-table-row-cursor-tooltip border-priamryGray-16 rounded-md border bg-white p-2 text-tiny font-normal text-primaryGray-3 shadow-lg"
      style={computeCursorTopTooltipPosition(
        tooltip.clientX,
        tooltip.anchorTop,
      )}
    >
      {tooltip.content}
    </div>,
    document.body,
  );
};
